export default "__VITE_ASSET__4bc0052e__"